import { HomepageBelowFoldExperimentData } from '@app/code/src/components/Homepage/HomepageStaticContent/variants/types'

export const LOCGPageDescription =
  'Create a free custom QR code now! With colors, patterns, privacy,  and analytics, Flowcode is the #1 free QR code generator. Download your code today.'
export const LOCGPageTitle = 'Free QR Code Generator | Flowcode'
export const HomePageBelowFoldMockData = [
  {
    primary: {
      header: [{ type: 'heading2', text: 'How can I create a QR code for free?', spans: [] }],
      subheader: [
        {
          type: 'paragraph',
          text: 'Follow these easy steps to generate a free Flowcode QR code, then scroll up to make your first code!',
          spans: []
        }
      ]
    },
    items: [],
    id: 'ways-to-use_carousel_1$113ef237-cbff-4a92-b799-4f70fcebd701',
    slice_type: 'ways-to-use_carousel_1',
    slice_label: null
  },
  {
    primary: { subheader: [{ type: 'heading2', text: '', spans: [] }] },
    items: [
      {
        image: {
          dimensions: { width: 784, height: 396 },
          alt: 'Select Scan Destination',
          copyright: null,
          url: '/graphics/locg/LOCG_step1.png',
          id: 'Zh1bDRcAACcAlf5Z',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading3', text: 'Select your scan destination', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Whether you want to figure out how to make a QR code for a website or send people to an online menu, Flowcode offers easy ways to connect people to digital destinations. Simply select your scan destination and paste the necessary website link where it says "Enter or paste a URL".',
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Left'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 782, height: 395 },
          alt: 'Colorful QR Code',
          copyright: null,
          url: '/graphics/locg/LOCG_step2.png',
          id: 'Zh1btBcAACgAlgFA',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [
          { type: 'heading3', text: 'Make it pop! Add color to your QR code ', spans: [] }
        ],
        description: [
          {
            type: 'paragraph',
            text: 'Can a QR code be any color? With Flowcode, they can. Get creative and skip the black and white codes! Select from a range of colors to match your brand, personality, or marketing collateral. ',
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      },
      {
        image: {
          dimensions: { width: 803, height: 398 },
          alt: 'QR code shape',
          copyright: null,
          url: '/graphics/locg/LOCG_step3.png',
          id: 'Zh1cOBcAACcAlgOL',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading3', text: 'Choose your QR code shape', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: "Custom shape QR codes do exist — and they're available with Flowcode. Whether you want to build a code  in the shape of a circle or square, select either option for a custom shape to match your brand.",
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [{ type: 'paragraph', text: '', spans: [] }],
        value_props_images: [{ type: 'paragraph', text: '', spans: [] }],
        image_alignment: 'Left'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 697, height: 394 },
          alt: 'QR code with frame',
          copyright: null,
          url: '/graphics/locg/LOCG_step4.png',
          id: 'Zh1cpRcAACUAlgVx',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading3', text: 'Add a frame', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Boost the number of scans for your QR code by adding a frame with a CTA. QR codes with a CTA receive 2x the number of scans as traditional codes.  ',
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 806, height: 396 },
          alt: 'QR code with logo',
          copyright: null,
          url: '/graphics/locg/LOCG_step5.png',
          id: 'Zh1c1BcAACgAlgZE',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading3', text: 'Upload your logo', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: "If you’re searching for a QR code generator with logos, look no further. Upload your brand's logo and re-size it to fit your needs. Just make sure the file you upload is smaller than 5mb.",
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Left'
      },
      {
        image: {
          dimensions: { width: 790, height: 392 },
          alt: 'QR code PNG',
          copyright: null,
          url: '/graphics/locg/LOCG_step6.png',
          id: 'Zh1hdxcAACgAlhrt',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading3', text: 'Download your code!', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Now, it’s the fun part. After completing steps one through five, simply create an account with your Gmail, Facebook, or enter your email and password. Then, click “download”. Your QR code PNG will be waiting for you, but feel free to download your code as a JPG or SVG too.',
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Tertiary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      }
    ],
    id: 'large_product_card$0ca27d54-8789-4a12-982f-829994ede690',
    slice_type: 'large_product_card',
    slice_label: null
  },
  {
    primary: { subheader: [] },
    items: [
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1001, height: 701 },
          alt: 'QR code generator API',
          copyright: null,
          url: '/graphics/locg/AnalyticsAPI.png',
          id: 'ZF0PUhAAACAAxGkH',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading2', text: 'Access our QR code API', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Ready to make hundreds or thousands of QR codes at scale? By using our API, you can create codes in bulk, integrate the creation into your own systems, and view comprehensive analytics.',
            spans: []
          }
        ],
        button_label: 'View the developer portal',
        button_variant: 'Primary',
        button_href: { link_type: 'Web', url: 'https://www.flowcode.com/developer-portal' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      }
    ],
    id: 'large_product_card$c5f62e8b-3bf0-44f6-b8f4-057befcb9d05',
    slice_type: 'large_product_card',
    slice_label: null
  },
  {
    primary: {
      header: [
        { type: 'heading2', text: 'A QR code generator built for every industry', spans: [] }
      ],
      button_label: 'Create a Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          dimensions: { width: 706, height: 706 },
          alt: 'QR code for real estate',
          copyright: null,
          url: '/graphics/locg/RealEstate.png',
          id: 'Y4-mBxAAACEAvH1G',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [
          { type: 'heading3', text: 'QR Codes for Real Estate Agents', spans: [] }
        ],
        text: [
          {
            type: 'paragraph',
            text: 'QR codes for real estate are a hack you need to grow your business. Whether you want to drive buyers and sellers to listings fast or provide more info to customers with in-depth details, Flowcode QR codes can be added to your selling kit.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Learn more real estate tips',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/realestate',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 706, height: 706 },
          alt: 'QR code rsvp',
          copyright: null,
          url: '/graphics/locg/Wedding.png',
          id: 'Y4-mBxAAACAAvH1I',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Weddings', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Say “I do” to using Flowcode QR codes at weddings. From creating wedding invites with QR codes to building weekend schedules, Flowcode is the strongest solution for couples looking to use innovative technology for their weddings.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [{ type: 'paragraph', text: '', spans: [] }],
        button_label: 'Discover more wedding tips',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/wedding',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 707, height: 706 },
          alt: 'Web3 QR code',
          copyright: null,
          url: '/graphics/locg/Web3.png',
          id: 'Y4-mBxAAACAAvH1A',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Web3', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'The Metaverse is being accessed with QR codes — are you coming? From providing secure access to digital assets to facilitating frictionless sharing of NFTs, QR codes for Web3 need to be apart of your business strategy.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [{ type: 'paragraph', text: '', spans: [] }],
        button_label: 'Explore solutions for Web3',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/web3',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 706, height: 706 },
          alt: 'QR code for events',
          copyright: null,
          url: '/graphics/locg/Event.png',
          id: 'Y4-mHxAAAB8AvH1_',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Events', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Planning an event soon? Leverage Flowcode QR codes to make it a more seamless operation by securely checking in guests, connecting people to online merchandise, sharing program information, and so much more.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Get QR codes for events',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/events',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 707, height: 707 },
          alt: 'QR code for designers',
          copyright: null,
          url: '/graphics/locg/Freelancer.png',
          id: 'Y4-mBxAAACEAvH1H',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Designers', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Elevate your product with Flowcode QR codes. With artistic designs and customizable functionality, Flowcodes can quickly drive people to any virtual destination in style.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Learn how designers use QR code',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/designers',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 707, height: 706 },
          alt: 'QR codes for marketers',
          copyright: null,
          url: '/graphics/locg/Marketing.png',
          id: 'Y4-mBxAAACAAvH1E',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Marketers', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Flowcode QR codes help you connect with customers at scale customers. Leverage QR to rapidly connect scanners to online stores, social profiles, sweepstakes, promos, and more. Drive conversions while you collect CRM and gather information about your customers in the offline world. ',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Elevate your marketing',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/marketers',
          target: '_blank'
        }
      }
    ],
    id: 'testimonials_carousel$17351fab-476c-4d39-a14f-eaafc4af6017',
    slice_type: 'testimonials_carousel',
    slice_label: null
  },
  {
    primary: {
      header: [{ type: 'heading2', text: 'Discover unique uses for QR codes', spans: [] }],
      button_label: 'Design your Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'QR codes for app downloads',
          copyright: null,
          url: '/graphics/locg/UseCaseAppDownload.jpg',
          id: 'Y6X6QBAAANQzAceF',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for App Downloads', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Pushing an app to new users and want a rapid way to distribute it? Use Flowcode QR codes! With one scan of a smartphone, users can be automatically directed to either the Apple or Android app store depending on their device type.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Create a code for your app',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-app-downloads',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'QR code business cards',
          copyright: null,
          url: '/graphics/locg/UseCaseBusinessCard.jpg',
          id: 'Y6X6QBAAAOoJAceG',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Business Cards', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Take your networking to the next level with QR code business cards. Whether you want to share a QR code with contact information or instantly connect prospects to your digital destinations, adding a designed Flowcode QR code to your business card can help you get more leads.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Build a better business card',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-business-cards',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'CRM QR code',
          copyright: null,
          url: '/graphics/locg/UseCaseCollectingCRM.jpg',
          id: 'Y6X6wxAAAOoJAcg9',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },

        testimonial_title: [{ type: 'heading3', text: 'QR Codes for CRM', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Looking to collect more contacts? Flowcode QR codes can seamlessly support your efforts to build your marketing database. One scan of a code can automatically integrate to your CRM of choice like Hubspot, Mailchimp, Klavyio, and more.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Collect more contacts',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-crm',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'Direct mail QR code',
          copyright: null,
          url: '/graphics/locg/UseCaseDirectMail.jpg',
          id: 'Y6X7ERAAACQAAciw',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        testimonial_title: [{ type: 'heading3', text: 'QR Codes for Direct Mail', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'A QR code postcard? Oh yeah, it’s a great idea. If you’re looking to track the engagement of your direct mail campaigns try putting a Flowcode on your mailers. You can track, scans, sessions to your site, and measure whether or not your campaign is successful. ',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Power up your direct mail',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-direct-mail',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'QR codes product packaging ',
          copyright: null,
          url: '/graphics/locg/UseCaseProductPackaging.jpg',
          id: 'Y6X7VhAAAOoJAckR',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        testimonial_title: [
          { type: 'heading3', text: 'QR Codes for Product Packaging', spans: [] }
        ],
        text: [
          {
            type: 'paragraph',
            text: 'QR codes on products allow you to educate buyers about your product, drive people to website, and communicate information about materials with just one scan!',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Strengthen your product visibility',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-product-packaging',
          target: '_blank'
        }
      }
    ],
    id: 'testimonials_carousel$e7769d8e-f9a2-4611-9d9b-b9b8c8f6340e',
    slice_type: 'testimonials_carousel',
    slice_label: null
  },
  {
    primary: {
      header: [{ type: 'heading2', text: 'Benefits of using QR codes', spans: [] }],
      button_label: 'Make your own Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          dimensions: { width: 706, height: 706 },
          alt: 'QR codes TV',
          copyright: null,
          url: '/graphics/locg/TV.png',
          id: 'Y8h-HBAAADl3VvY_',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'Collect first party data', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'QR codes on TV help you capture first party data you previously never had access to. Flowcode QR codes in your commercial or digital campaign lets scanners instantly connect with any digital destination you’re trying to promote. When someone scans your code they get directed to the location of your choice, and you get details on the time of scan and device type.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Own your data',
        button_variant: 'Secondary',
        button_href: { link_type: 'Web', url: 'https://www.flowcode.com/tv', target: '_blank' }
      },
      {
        image: {
          dimensions: { width: 707, height: 707 },
          alt: 'QR code social media',
          copyright: null,
          url: '/graphics/locg/Influencer.png',
          id: 'Y8h-HBAAADl3VvZA',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [
          { type: 'heading3', text: 'Drive offline engagement and loyalty', spans: [] }
        ],
        text: [
          {
            type: 'paragraph',
            text: 'Social media QR codes can help drive frictionless engagement to your different channels. Display your code in your store, at an event, or on your products! With the scan of a phone camera, quickly send new customers to your social profiles. And with Flowcode, you can print your QR code in any color and make it pop!  ',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Get more engagement',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-online-purchases',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 707, height: 707 },
          alt: 'QR code label',
          copyright: null,
          url: '/graphics/locg/Retail.png',
          id: 'Y8h-GxAAAHa6VvY-',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'Educate customers', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Flowcode QR codes send customers to any online destination, so it’s common for brands to use them as educational tools. Send customers to your company story, information about product materials, or even where they can buy your product in town!  Put a QR code on a product, a label, or a piece of clothing and see the impact of giving your customers more ways to explore your digital channels.',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Teach your customers',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/industry/retail',
          target: '_blank'
        }
      },
      {
        image: {
          dimensions: { width: 1000, height: 1000 },
          alt: 'Get more google reviews',
          copyright: null,
          url: '/graphics/locg/UseCaseCollectingSurveys.jpg',
          id: 'Y8h-GxAAAMPMVvY5',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        'author-logo': {
          dimensions: { width: 500, height: 500 },
          alt: null,
          copyright: null,
          url: 'https://images.prismic.io/flowcode-ui/4a954f61-67d0-4a52-a6ef-4bf6b9d51c98_54952956-square-transparent-background-black-and-white-seamless-pattern--removebg-preview+%281%29.png?auto=compress,format',
          id: 'Y4-vshAAACAAvKCi',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        testimonial_title: [{ type: 'heading3', text: 'Collect more reviews', spans: [] }],
        text: [
          {
            type: 'paragraph',
            text: 'Want to get more Google reviews for your business? Flowcode QR codes make the process frictionless. Put a QR code on a receipt, on your store window, or on a packaging insert with your online store order. By adding the review site website to your QR code, you can send scanners directly to a place to give feedback (and get more 5 star reviews)!',
            spans: []
          }
        ],
        is_body_bold: false,
        author: [],
        'additional-text': [],
        button_label: 'Get 5 stars',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-collecting-surveys',
          target: '_blank'
        }
      }
    ],
    id: 'testimonials_carousel$bc20f098-eba4-48cf-b07c-b66f6653194f',
    slice_type: 'testimonials_carousel',
    slice_label: null
  },
  {
    primary: { subheader: [] },
    items: [
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1920, height: 1344 },
          alt: 'High converting QR code',
          copyright: null,
          url: '/graphics/locg/Highest-converting-qr-code.jpg',
          id: 'ZEb6VREAAB8AJZvc',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        subheader: [
          { type: 'heading2', text: 'The highest converting QR code on the market', spans: [] }
        ],
        description: [
          {
            type: 'paragraph',
            text: 'Due to different shapes, colors, and patterns, Flowcodes get 18% higher scans than other QR code generator platforms. In order to stand out from the pack and get more scans, customization is key!',
            spans: []
          }
        ],
        button_label: null,
        button_variant: 'Primary',
        button_href: { link_type: 'Any' },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Left'
      }
    ],
    id: 'large_product_card$52d1d41b-274d-445f-a95a-469339471e2b',
    slice_type: 'large_product_card',
    slice_label: null
  },
  {
    primary: {
      subheader: [
        { type: 'heading3', text: 'Trusted by people and businesses around the world', spans: [] }
      ],
      image: {
        dimensions: { width: 1920, height: 1344 },
        alt: 'Trusted by people and businesses around the world',
        copyright: null,
        url: '/graphics/locg/Businesses.png',
        id: 'ZEb6VREAAB8AJZvc',
        edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
      }
    },
    id: 'contact_sales_page_used_by_footer$ba862db3-3203-4ace-8de7-8bb236323bc1',
    slice_type: 'contact_sales_page_used_by_footer',
    slice_label: null
  },
  {
    primary: {
      heading: [
        { type: 'heading2', text: 'Free QR code generator with the best features', spans: [] }
      ],
      footer: []
    },
    items: [
      {
        title: [{ type: 'heading2', text: 'Fully customizable QR code', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Flowcode lets you customize every feature of your QR code. Whether you want to change the pattern of your code, the color, or image inside the code, Flowcode gives you control to customize your QR code to match your brand. So, believe it or not, pretty QR codes do exist!',
            spans: []
          }
        ]
      },
      {
        title: [{ type: 'heading2', text: 'Beautiful QR code designs', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Well designed QR codes get 18% more engagement than standard black and white codes. If you’re looking for even more customization of your code, you can work with one of Flowcode’s in-house artists to make a code. We have designed custom codes for BMW, the NBA, ESPN, and thousands of businesses that want to stand out from the pack! ',
            spans: []
          }
        ]
      },
      {
        title: [{ type: 'heading2', text: 'Advanced QR code analytics', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'What information can you get when someone scans a Flowcode QR code that you create?  Details about the time of scan, device type, and zip code are all information you can analyze. At Flowcode, we call the information you get “Flowlytics”, and it’s all real-time data. That means the moment you get a scan, you know. This is why Flowcode has the most powerful analytics tool of any QR code provider.',
            spans: []
          }
        ]
      },
      {
        title: [{ type: 'heading2', text: 'The safest QR code on the market', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Flowcode is the most secure  QR code provider on the market. We take your privacy seriously, and back it up with the top certifications necessary to ensure anyone scanning the code you create is protected. With GDPR and CCPA compliance, Flowcode protects your business and your customers.',
            spans: []
          }
        ]
      }
    ],
    id: 'accordion$c21d4afc-f46a-4c8a-8792-0dc05b878bea',
    slice_type: 'accordion',
    slice_label: null
  },
  {
    primary: {
      header: [{ type: 'heading2', text: 'What can be done with QR codes?', spans: [] }],
      subheader: [
        {
          type: 'paragraph',
          text: 'QR codes can be used in hundreds of ways, but the most popular methods are sending people to digital destinations like PDFs, websites, or phone numbers.',
          spans: []
        }
      ]
    },
    items: [],
    id: 'ways-to-use_carousel_1$96810c9b-863e-4f27-a1b5-6d90bc5a19c4',
    slice_type: 'ways-to-use_carousel_1',
    slice_label: null
  },
  {
    primary: { subheader: [] },
    items: [
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1921, height: 1081 },
          alt: 'QR code to a PDF',
          copyright: null,
          url: '/graphics/locg/pdf-to-qr-code.png',
          id: 'ZD3OrREAACAA_dpY',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading2', text: 'PDF to QR code', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: "QR codes can send scanners to any PDF, like restaurant menus or instructional guides. Wondering how to make a QR code for a PDF? Using Flowcode's free qr code generator you can easily upload your PDF and create a free QR code.",
            spans: []
          }
        ],
        button_label: 'Read about QR codes for PDFs',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/blog/how-to-connect-a-qr-code-to-a-pdf'
        },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Left'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1921, height: 1081 },
          alt: 'QR code sticker',
          copyright: null,
          url: '/graphics/locg/qr-code-sticker.png',
          id: 'ZD3O1REAACEA_dsN',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading2', text: 'QR code sticker', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'Want to print your QR code as a sticker and get it into the real world? Whether you want to make an Instagram QR code sticker or a Venmo QR code sticker, Flowcode lets you create a QR code for free and then print',
            spans: []
          }
        ],
        button_label: 'Make a QR code sticker',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/blog/printing-your-flowcode'
        },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1921, height: 1081 },
          alt: 'QR code business card',
          copyright: null,
          url: '/graphics/locg/qr-code-business-card.png',
          id: 'ZD3QThEAAB8A_eF_',
          edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
        },
        subheader: [{ type: 'heading2', text: 'QR code business card', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'If you need to modernize your business card, look no further than QR codes. By creating a QR code for your business card you can instantly connect people who scan your code to a phone call, a website, portfolio, and more.',
            spans: []
          }
        ],
        button_label: 'Make a QR code business card',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/use-cases/qr-codes-for-business-cards'
        },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Left'
      },
      {
        'logo-title': {},
        image: {
          dimensions: { width: 1921, height: 1081 },
          alt: 'QR code sign',
          copyright: null,
          url: '/graphics/locg/qr-code-sign.jpg',
          id: 'ZD3RghEAAB8A_ebO',
          edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
        },
        subheader: [{ type: 'heading2', text: 'Create a QR code sign', spans: [] }],
        description: [
          {
            type: 'paragraph',
            text: 'When you create a QR code for your sign, billboard, or packaging you can track the effectiveness of your offline campaigns and evaluate the return of investment.',
            spans: []
          }
        ],
        button_label: 'Learn more about QR code signs',
        button_variant: 'Secondary',
        button_href: {
          link_type: 'Web',
          url: 'https://www.flowcode.com/blog/qr-signage-best-practices'
        },
        value_props_list: [],
        value_props_images: [],
        image_alignment: 'Right'
      }
    ],
    id: 'large_product_card$48456cdd-bfdc-4fec-a556-4c1601a16462',
    slice_type: 'large_product_card',
    slice_label: null
  },
  {
    primary: {
      header: [{ type: 'heading3', text: 'Join an educational webinar!', spans: [] }],
      image: {
        dimensions: { width: 1001, height: 1001 },
        alt: 'Webinar icon',
        copyright: null,
        url: '/graphics/locg/Webinar.png',
        id: 'ZICvCxEAACcAk8uQ',
        edit: { x: 0, y: 0, zoom: 1, background: 'transparent' }
      },
      description: [
        {
          type: 'paragraph',
          text: "Class is in session! Educational webinars are happening every week, and we'd love for you to attend one! From tips to leverage QR code solutions to feature deep dives, our team is ready to help you make more offline connections. If you have questions, please email  support@flowcode.com to get in touch.",
          spans: [{ start: 266, end: 286, type: 'strong' }]
        }
      ],
      address: [],
      button_href: { link_type: 'Web', url: 'https://www.flowcode.com/page/flowcodewebinars' },
      button_label: 'Join a webinar',
      button_variant: 'Secondary'
    },
    items: [{}],
    id: 'creators_office_hours_card$1e0bcaf5-7d5a-4e0c-83a2-b9ff40909512',
    slice_type: 'creators_office_hours_card',
    slice_label: null
  },
  {
    primary: {
      heading: [
        { type: 'heading2', text: 'FAQs about QR codes and QR code generators', spans: [] }
      ],
      cta1_img: {
        dimensions: { width: 24, height: 24 },
        alt: 'Get help',
        copyright: null,
        url: '/graphics/locg/handshake.svg',
        id: 'ZDls-hEAAB8A6sDX',
        edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
      },
      cta1_line1: [{ type: 'paragraph', text: 'Still have questions?', spans: [] }],
      cta1_line2: [
        {
          type: 'paragraph',
          text: 'Talk with an expert →',
          spans: [
            {
              start: 0,
              end: 21,
              type: 'hyperlink',
              data: { link_type: 'Web', url: 'https://www.flowcode.com/contact-sales' }
            }
          ]
        }
      ],
      cta2_img: {
        dimensions: { width: 24, height: 24 },
        alt: 'Help center',
        copyright: null,
        url: '/graphics/locg/help_center.svg',
        id: 'ZDltVxEAAAHa6sJ7',
        edit: { x: 0, y: 0, zoom: 1, background: '#fff' }
      },
      cta2_line1: [{ type: 'paragraph', text: 'Visit our help center for more info', spans: [] }],
      cta2_line2: [
        {
          type: 'paragraph',
          text: 'Visit help center →',
          spans: [
            {
              start: 0,
              end: 19,
              type: 'hyperlink',
              data: { link_type: 'Web', url: 'https://help.flowcode.com/en/' }
            }
          ]
        }
      ]
    },
    items: [
      {
        question: [{ type: 'heading2', text: 'What is a QR code?', spans: [] }],
        answer: [
          {
            type: 'paragraph',
            text: 'A QR code (short for Quick Response code) is a two-dimensional barcode that can be scanned by camera-equipped device such as Apple or Android smartphones. QR codes can store a range of information. From website URLs and contact information to product details and social profiles, QR codes are often used for marketing and advertising purposes. There are many companies that produce QR codes, but Flowcode has the strongest features and offerings for businesses and creators of all sizes.',
            spans: [
              {
                start: 396,
                end: 404,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [{ type: 'heading2', text: 'What are the benefits of QR Codes?', spans: [] }],
        answer: [
          {
            type: 'paragraph',
            text: "At their core, QR codes offer a convenient way for rapid connection, and connect the offline world to digital destinations. If you're a business, you can use  QR codes to promote products, collect contacts, provide customers with access to discounts, and more! For individuals creators, QR codes can be used to access websites, share contact information, and connect with businesses rapidly. QR codes are also more secure than traditional barcodes, making them useful for tasks such as transferring tickets and tracking inventory. When it comes down to it, QR codes are extremely versatile products that can be used for both print and digital media, making them a great way to increase engagement with your audience.",
            spans: []
          }
        ]
      },
      {
        question: [{ type: 'heading2', text: 'Are QR codes free?', spans: [] }],
        answer: [
          {
            type: 'paragraph',
            text: 'QR codes are generally free to generate and use. There are multiple online platforms that allow users to generate QR codes for free. However, if you are looking for more advanced features and customization of the QR code, you may have to pay for a service. If you are searching for the best free QR code generator to get started, Flowcode offers robust customization and features for creators like logos, colors, and patterns.',
            spans: [
              {
                start: 330,
                end: 338,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [
          { type: 'heading2', text: 'How can I use QR codes for my business?', spans: [] }
        ],
        answer: [
          {
            type: 'paragraph',
            text: 'QR codes are a great way to market your business, connect directly with your audience offline, and increase customer engagement to your digital channels. They can be used to link customers directly to a PDF, your website, special offers, digital content, or any other information you wish to share. They are also easy to create and can be quickly scanned with most smart phones, making them great for customer interaction and collecting CRM. Whether you want to use codes to track customer behavior or engagement, QR codes help you to better understand customer preferences and develop better strategies for your business. To make a free QR code and start testing new ways to connect with your customers, use Flowcode’s free QR code generator.',
            spans: [
              {
                start: 709,
                end: 719,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [{ type: 'heading2', text: 'How do QR codes work?', spans: [] }],
        answer: [
          {
            type: 'paragraph',
            text: 'QR codes are a type of two-dimensional barcode that stores data in a structured, machine-readable format. These codes mostly consist of an assortment of black and white squares arranged in a specific pattern. However, some companies like Flowcode offer different shapes, patterns, and colors to make your QR code pop. When scanned with a smartphone camera, the code is able to quickly and accurately decode the data it holds and perform an action, such as opening a website, sending an email, or connecting to WiFi. There are many platforms that let you create a QR code, but Flowcode has the #1 free QR code generator because of the customization features you get. ',
            spans: [
              {
                start: 300,
                end: 316,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              },
              {
                start: 576,
                end: 584,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [{ type: 'heading2', text: 'Can I generate a QR code for free?', spans: [] }],
        answer: [
          {
            type: 'paragraph',
            text: 'Yes, you can create a QR code for free. All you need is an internet connection and a free QR code generator. There are many free online QR code generators available, but Flowcode is the most powerful platform. Simply enter the data you want to encode (this could be a website, a PDF, an image, or any other digital destination) in the QR code into the generator, and it will generate a code for you. Customize the shape, pattern, and design of your code, then download it in various formats such as PNG, SVG, and EPS.',
            spans: [
              {
                start: 170,
                end: 178,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [
          { type: 'heading2', text: 'What is the safest online QR code generator?', spans: [] }
        ],
        answer: [
          {
            type: 'paragraph',
            text: 'The safest QR code generator is Flowcode. With GDPR, CCPA, and SOC2 compliance, the privacy and data of the people scanning your codes is always protected. With Flowcode, you can also expect robust security features, such as customizable access rules, secure encryption, and secure storage of the generated codes. With phishing and scam attempts on the rise, QR codes have become a vessel for bad actors. Good QR code generators should provide tools for mitigating such attempts. Through testing and validating the codes, as well as features for tracking code usage, companies like Flowcode are the most secure. ',
            spans: []
          }
        ]
      },
      {
        question: [
          { type: 'heading2', text: 'What is the best free QR code generator?', spans: [] }
        ],
        answer: [
          {
            type: 'paragraph',
            text: 'The best free QR code generator is Flowcode. There are many QR code platforms available, but most of them just offer free trials. Flowcode is a completely free online QR code generator that allows you to create unique QR codes. It is easy to use and provides a variety of features such as the ability to customize the design, pattern, color, and features the ability to track the code once it has been scanned. On top of this, Flowcode has an all-star customer support team who are available to help whenever you need it! ',
            spans: [
              {
                start: 35,
                end: 43,
                type: 'hyperlink',
                data: { link_type: 'Web', url: 'https://www.flowcode.com/free-qr-code-generator' }
              }
            ]
          }
        ]
      },
      {
        question: [
          { type: 'heading2', text: 'What is the disadvantage of free QR code?', spans: [] }
        ],
        answer: [
          {
            type: 'paragraph',
            text: "Free QR codes typically are static — this means, when you produce a code, you can never change the online destination that it scans to. However, if you're looking for a free QR code with no downside, the clear answer is Flowcode. All of the codes are dynamic, meaning you can change the destination of your code even after you create it.",
            spans: []
          }
        ]
      }
    ],
    id: 'faqs$b42ffd84-f88c-4019-aae1-86eacb8369b7',
    slice_type: 'faqs',
    slice_label: null
  },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  { slice_type: 'faq' },
  {
    primary: {
      header: [
        {
          type: 'heading2',
          text: 'Turn real-world experiences into digital consumers',
          spans: []
        }
      ],
      subheader: [
        {
          type: 'heading3',
          text: 'Used by over 10,000 businesses and 5 million individuals across\n100+ countries with proven results.',
          spans: []
        }
      ],
      button_label: 'Request a demo',
      button_href: { link_type: 'Web', url: 'https://www.flowcode.com/contact-sales' },
      button_variant: 'Primary'
    },
    items: [{}],
    id: 'footer_attachement$b912ae63-3de3-45e6-b6e2-e27546b7537a',
    slice_type: 'footer_attachement',
    slice_label: null
  }
] as HomepageBelowFoldExperimentData['v2']
